import { AxiosInstance } from "axios";
import { ShippingSettings } from "../models/shipping";

const SHIPPING_API_PREFIX = "/shipping";

// The http interceptor converts response keys to camelCase before we see them.
type CamelShippingSettings = {
	provider: string;
	baseFee: number;
	freeShippingThreshold: number;
	currency: string;
};

export async function getShippingSettings(
	http: AxiosInstance
): Promise<ShippingSettings> {
	const body = await http.get<any>(`${SHIPPING_API_PREFIX}/settings`);
	const raw = body.data as CamelShippingSettings;
	return {
		provider: raw.provider,
		baseFee: Number(raw.baseFee ?? 0),
		freeShippingThreshold: Number(raw.freeShippingThreshold ?? 0),
		currency: raw.currency,
	};
}
